var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3025 19.0693C33.7437 18.7263 35.6232 16.6333 35.6285 14.0975C35.6285 11.5985 33.8067 9.52652 31.418 9.13452",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5251 24.9382C36.8894 25.2917 38.5396 26.1195 38.5396 27.8257C38.5396 29 37.7626 29.763 36.5061 30.2425",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8011 25.6619C15.1766 25.6619 10.3728 26.5141 10.3728 29.9179C10.3728 33.3199 15.1468 34.1966 20.8011 34.1966C26.4256 34.1966 31.2276 33.3531 31.2276 29.9476C31.2276 26.5421 26.4553 25.6619 20.8011 25.6619Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8022 20.8038C24.4929 20.8038 27.4854 17.813 27.4854 14.1205C27.4854 10.4298 24.4929 7.43726 20.8022 7.43726C17.1114 7.43726 14.1189 10.4298 14.1189 14.1205C14.1049 17.799 17.0747 20.7915 20.7532 20.8038H20.8022Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2984 19.0693C7.85541 18.7263 5.97766 16.6333 5.97241 14.0975C5.97241 11.5985 7.79416 9.52652 10.1829 9.13452",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07676 24.9382C4.71251 25.2917 3.06226 26.1195 3.06226 27.8257C3.06226 29 3.83926 29.763 5.09576 30.2425",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.99812728582722910aedbe51490febbe.svg";
export { ForwardRef as ReactComponent };